import axios from '../../axios'

/*
 * 校考信息管理接口
 */

// 创建统考信息
export const createXKInfo = (data) => {
    return axios({
        url: '/api/data/wish/schoolstat',
        method: 'POST',
        data
    })
}

// 获取校考信息详情
export const getXKInfomation = (data) => {
    return axios({
        url: '/api/data/wish/schoolstat/info',
        method: 'get',
        data
    })
}

// 修改校考信息
export const editXKInfo = (data) => {
    return axios({
        url: '/api/data/wish/schoolstat',
        method: 'PUT',
        data
    })
}

// 删除校考信息
export const delXKInfo = (data) => {
    return axios({
        url: '/api/data/wish/schoolstat',
        method: 'DELETE',
        data
    })
}

// 获取校考信息列表
export const getXKList = (data) => {
    return axios({
        url: '/api/data/wish/schoolstat',
        method: 'GET',
        data
    })
}

// 关键词模糊搜索
export const searchXKinfo = (data) => {
    return axios({
        url: '/api/data/wish/search/schoolstat',
        method: 'GET',
        data
    })
}

// 校考信息导入接口
export const importXKinfo = (data) => {
    return axios({
        url: '/api/data/wish/schoolstat/import',
        method: 'POST',
        data
    })
}

// 校考信息导出接口
export const exportXKinfo = (data) => {
    return axios({
        url: '/api/data/wish/schoolstat/export',
        method: 'POST',
        data
    })
}

// 校考信息更新接口
export const updataXKinfo = (data) => {
    return axios({
        url: '/api/data/wish/schoolstat/batch/update',
        method: 'POST',
        data
    })
}

// 校考信息批量删除接口
export const queryDelXKinfo = (data) => {
    return axios({
        url: '/api/data/wish/schoolstat/batch/delete',
        method: 'POST',
        data
    })
}




// WEBPACK FOOTER //
// ./src/http/moudules/dataManage/xkinfo.js